module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [(_vm.time) ? _c('div', {
    staticStyle: {
      "font-size": "14px",
      "padding": "10px"
    }
  }, [_vm._v("\n    您于" + _vm._s(_vm.time) + "开通联盟商家。\n  ")]) : _vm._e(), _vm._v(" "), _c('iframe', {
    staticClass: "iframe-box",
    attrs: {
      "src": _vm.filePath
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1250cdaa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/league-business/leagueAgreement.vue
// module id = 1533
// module chunks = 1